export default "/images/vendor/flag-icon-css/flags/1x1/az.svg?84126238074d3c3c30b970dc95e07324";